<template>
  <div class="top-level-groups-wrapper">
    <div class="pb-4">
      <div class="w-full grid grid-cols-2 text-center pb-24">
        <div class="top-level-group-item" @click="setSchengenZone('schengen')" :class="{ active: schengenZone == 'schengen'}">
          <span class="bubble"></span> <WFTranslate k="schengen-zone">Schengen Zone</WFTranslate>
        </div>
        <div class="top-level-group-item" @click="setSchengenZone('nonschengen')" :class="{ active: schengenZone == 'nonschengen'}">
          <span class="bubble"></span> <WFTranslate k="non-schengen">Non-Schengen Zone</WFTranslate>
        </div>
      </div>
      <div v-if="schengenZone === 'schengen'" class="schengen-information gates-a" :class="{opened: schengenZoneInfoOpened}">
        <div class="schengen-toggler flex items-center">
          <WFTranslate k="info-about-schengen-zone">Info about Schengen Zone. Gates-A</WFTranslate>
        </div>
        <div class="schengen-info-details">
          <WFTranslate k="info-about-schengen-zone-details">For gates starting with A, this zone allows free movement between Schengen countries without border checks.</WFTranslate>
        </div>
      </div>
      <div v-if="schengenZone === 'nonschengen'" class="schengen-information gates-b" :class="{opened: schengenZoneInfoOpened}">
        <div class="schengen-toggler flex items-center">
          <WFTranslate k="info-about-schengen-zone">Info about Non-Schengen Zone. Gates-B</WFTranslate>
        </div>
        <div class="schengen-info-details">
          <WFTranslate k="info-about-non-schengen-zone-details">For gates starting with B, this zone includes border control and customs checks for international travel outside the Schengen zone.</WFTranslate>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import {mapState} from "vuex";

export default {
  data() {
    return {
      schengenZoneInfoOpened: true
    }
  },
  computed: {
    ...mapState('wf', ['language']),
    schengenZone() {
      return this.$store.state.schengenZone;
    }
  },
  methods: {
    setSchengenZone (zone) {
      this.$store.dispatch('setSchengenZone', zone);
      this.$store.dispatch('setPOI', null);
      this.$store.dispatch('resetMainTab');
    },
    toggleSchengenZoneInfoOpened () {
      this.schengenZoneInfoOpened = !this.schengenZoneInfoOpened;
    },
  },
}
</script>

<style lang="postcss">
  .schengen-info-details {
    font-size: 1.6rem;
    font-weight: 400;
    padding-top: 1.5rem;
  }
  .schengen-information {

    color: #fff;
    border-radius: 12px;
    padding: 1.2rem 2.6rem;
    background: #2868E8;

    .schengen-toggler {
      .svg-wrapper {
        display: inline-block;
        border: 1px solid #fff;
        border-radius: 50%;
        padding: 0.4rem;

        svg {
          transition: 0.5s;
          path {
            fill: #fff;
          }
        }
      }
      label {
        display: inline-block;
        font-size: 1.9rem;
        font-weight: 600;
      }
    }
    .schengen-info-details {
      display: none;
    }

    &.opened {
     .svg-wrapper {

       svg {
         transition: 0.5s;
         transform: rotate(45deg);
       }
     }
      .schengen-info-details {
        display: block;
      }
    }
  }

  .top-level-group-item {
    padding: 1.2rem;
    font-weight: 600;
    font-size: 1.8rem;
    border: 1px solid #0F417C;
    display: flex;
    align-items: center;
    justify-content: center;

    .bubble {
      display: inline-block;
      border-radius: 50%;
      height: 1.8rem;
      width: 1.8rem;
      background: #fff;
      border: 1px solid #fff;
      margin-right: 1rem;
      margin-bottom: 0.2rem;
    }

    &:first-child {
       border-top-left-radius: 32px;
       border-bottom-left-radius: 32px;
     }
    &:last-child {
       border-top-right-radius: 32px;
       border-bottom-right-radius: 32px;
     }
    &.active {
     background: #0F417C;
     color: #fff;
    }
  }
  @media (max-width: 1024px) {
    .top-level-group-item {
      font-size: 14px;
    }
  }
</style>
